import { Component } from 'react';
import { connect } from 'react-redux';
import { getThemePath } from '../../selectors/themeSelectors';
import * as Actions from '../../actions/Actions';
import { FONT_SETS } from 'ContentUtils/constants/Fonts';
import { makeAsyncComponent } from '../../utils/makeAsyncUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncFontPickerField = makeAsyncComponent(() => import( /* webpackChunkName: 'FontPickerField' */'ContentComponents/components/cmv2/fields/FontPicker'));
const mapStateToProps = state => ({
  themePath: getThemePath(state)
});
const mapDispatchToProps = {
  reloadThemePreview: Actions.reloadIframePreview
};
class FontPicker extends Component {
  constructor(...args) {
    super(...args);
    this.handleFieldChange = value => {
      const {
        onFieldChange,
        reloadThemePreview
      } = this.props;
      if (value.font_set === FONT_SETS.BRANDING) setTimeout(() => {
        reloadThemePreview();
      }, 500);
      onFieldChange(value);
    };
  }
  render() {
    return /*#__PURE__*/_jsx(AsyncFontPickerField, Object.assign({}, this.props, {
      onFieldChange: this.handleFieldChange
    }));
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(FontPicker);